
import React from "react";


import BaseLayout from "../components/layout/BaseLayout";
import PageHeader from "../components/general/PageHeader";

import NodeRankingTable from "../components/ranking/NodeRankingTable";
import WideTextContainer from "../components/layout/WideTextContainer";

import RankingSearchBox from "../components/ranking/RankingSearchBox";
import RankingSubscriberOnlyBadge from "../components/ranking/SubscriberOnlyBadge";
import RankingFaq from "../components/ranking/RankingFaq";
import DarkModeSwitch from "../components/layout/darkMode/DarkModeSwitch";
import DarkModeProvider from "../components/layout/darkMode/DarkModeProvider";




export default function PublicRankingPage() {
  const [search, setSearch] = React.useState<string>('');

  return (
    <DarkModeProvider>
      <BaseLayout pageTitle="Node Ranking"
        seoDescription="The best performing routing nodes in the network. High speed, liquid channels, well connected."
        shareDescription="The best performing routing nodes in the network. High speed, liquid channels, well connected."
        disableOnMaintenance={true}>
        <WideTextContainer>
          <div className="float-right pt-4">
          <DarkModeSwitch />
          </div>
          
          <PageHeader
            title={<div className="flex items-center flex-wrap gap-y-2">
              <div className="pr-4">
              Best Performing Routing Nodes
              </div>
              <RankingSubscriberOnlyBadge />
            </div>}
            align="left"
            description={<div className="font-light">
              <div>
                High speed, liquid channels, well connected. Ranking of LnRouter nodes.
              </div>
              <div className="font-normal pt-8">
                <RankingFaq />
              </div>

            </div>}
          />
        </WideTextContainer>


        <WideTextContainer>
          <RankingSearchBox onValueChanged={(text) => setSearch(text)} />
          <NodeRankingTable search={search} />
        </WideTextContainer>



      </BaseLayout>
    </DarkModeProvider>
  );
}
